<script setup lang="ts">
import { MenuSearchModal } from '@cplug/frontend-core/components'
import type { SearchableRoute } from '@cplug/frontend-core/models'
import { useErpSearchNavigate } from '~/domain/shared/navigation/composables/useErpSearchNavigate'
import { useRedirectToSubscriptionHub } from '~/domain/shared/navigation/composables/useRedirectToSubscriptionHub'
import { useERPSearchRoutes } from '~/domain/shared/navigation/composables/useERPSearchRoutes'

const { searchableRoutes, searchRoutes } = useERPSearchRoutes()

function handleNavigate (route: SearchableRoute): boolean {
  if (route.action === 'subscription-hub') {
    useRedirectToSubscriptionHub()
    return true
  }

  return useErpSearchNavigate(route)
}

const menuSearchModalBind = {
  storageKey: 'erp:recent-search-pages',
  fallbackRoutes: searchableRoutes,
  searchRoutesOverride: searchRoutes,
  onNavigate: handleNavigate
}
</script>

<template>
  <MenuSearchModal v-bind="menuSearchModalBind" />
</template>
